<vex-page-layout>
  <div
    *ngIf="isLoading"
    class="fixed w-full h-full inset-0 flex items-center justify-center z-50"
    style="background-color: rgba(0, 0, 0, 0.5)"
  >
    <mat-spinner [diameter]="100"></mat-spinner>
  </div>

  <vex-page-layout-header class="pb-4 flex flex-col justify-center items-end">
    <app-legend [legendItems]="legendData" class="-mt-6"></app-legend>
  </vex-page-layout-header>

  <vex-page-layout-content class="-mt-6">
    <div class="card overflow-auto -mt-16">
      <base-data-table-header
        [label]="entityName"
        [loading]="loading"
        [showSynchronization]="true"
        [showArchives]="canShowArchivePermission"
        (onSearchChange)="onSearchChange($event)"
        (onClearTextFilter)="clearTextFilter()"
        (onShowArchived)="onShowArchived($event)"
        (onSynchronization)="onSynchronization($event)"
        (onCreate)="createItem()"
        [canImport]="true"
        (onImport)="importItem()"
        [popupFilter]="true"
        (clearPopupFilter)="clearPopupFilter()"
        (validatePopupFilter)="validatePopupFilter()"
        [countPopupFilter]="countPopupFilter"
        [popupWidth]="700"
        headerPopupTitle="Filtres avancés"
        [templates]="[
          { template: toggleStatusTemplate, position: 1, place: 'after', isShowing: supplierTypesPermission }
        ]"
        [contentPopupTemplate]="contentPopupTemplate"
        [createPermission]="[ENUM_PERMISSION.CREATE_SUPPLIER]"
        [importPermission]="[ENUM_PERMISSION.CREATE_SUPPLIER]"
        [synchronizePermission]="[ENUM_PERMISSION.CREATE_SUPPLIER]"
      ></base-data-table-header>

      <base-data-table
        [count]="count"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
        [sortField]="sortField"
        [sortOrder]="sortOrder"
        [dataSource]="dataSource"
        [displayedColumns]="displayedColumns"
        [stickyTop]="true"
        [routerLinkDetailRow]="routerLinkDetailRow"
        [feisColumns]="feisColumns"
        (onPageEvent)="pageEvent($event)"
        (onSortEvent)="sortEvent($event)"
        (onUpdateItem)="updateItem($event)"
        (onDeleteItem)="deleteItem($event)"
        (onArchiveItem)="archiveItem($event)"
      ></base-data-table>
    </div>
  </vex-page-layout-content>
</vex-page-layout>

<ng-template #contentPopupTemplate>
  <form [formGroup]="popupForm">
    <base-form-input
      label="Famille d'achat"
      type="autocomplete"
      controlName="category"
      displayProperty="link"
      [items]="families$ | async"
    ></base-form-input>
  </form>
</ng-template>

<ng-template #toggleStatusTemplate>
  <div class="flex flex-row flex-wrap items-center">
    <mat-checkbox
      *ngFor="let type of supplierTypes"
      class="mx-2"
      [checked]="selectedSupplierTypes.includes(type)"
      (change)="onSupplierTypeChange(type, $event.checked)"
    >
      {{ type }}
    </mat-checkbox>
  </div>
</ng-template>
